import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@ridango/core';

import { CoreUiModule } from '../core-ui/core-ui.module';
import { PaymentMethodsActions, PaymentMethodsEpics, PaymentMethodsFacade } from './+state';
import { MultiplePaymentMethodsComponent } from './components/multiple-payment-methods/multiple-payment-methods.component';
import { SinglePaymentMethodComponent } from './components/single-payment-method/single-payment-method.component';
import { SwishLoadingComponent } from './components/swish-loading/swish-loading.component';
import { PaymentMethodsService } from './payment-methods.service';

@NgModule( {
    imports: [
        CoreModule,
        CommonModule,
        CoreUiModule,
        TranslateModule,
    ],
    declarations: [ SinglePaymentMethodComponent, MultiplePaymentMethodsComponent, SwishLoadingComponent ],
    providers: [
        PaymentMethodsService,
        PaymentMethodsActions,
        PaymentMethodsEpics,
        PaymentMethodsFacade
    ],
    exports: [ SinglePaymentMethodComponent, MultiplePaymentMethodsComponent, SwishLoadingComponent ]
} )
export class PaymentMethodsModule { }
